/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Balance } from '../model/balance';
import { ProblemDetails } from '../model/problemDetails';
import { Resource } from '../model/resource';
import { WalletBalanceResponse } from '../model/walletBalanceResponse';
import { WalletUpdateModel } from '../model/walletUpdateModel';
import { WalletUpdateModelDto } from '../model/walletUpdateModelDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WalletService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param balance 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletAddBalanceToWallet(balance: Balance, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public walletAddBalanceToWallet(balance: Balance, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public walletAddBalanceToWallet(balance: Balance, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public walletAddBalanceToWallet(balance: Balance, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (balance === null || balance === undefined) {
            throw new Error('Required parameter balance was null or undefined when calling walletAddBalanceToWallet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put(`${this.basePath}/api/Wallet/AddWalletBalance`,
            balance,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resource 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletAddResoureToWallet(resource: Resource, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public walletAddResoureToWallet(resource: Resource, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public walletAddResoureToWallet(resource: Resource, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public walletAddResoureToWallet(resource: Resource, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (resource === null || resource === undefined) {
            throw new Error('Required parameter resource was null or undefined when calling walletAddResoureToWallet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put(`${this.basePath}/api/Wallet/AddWalletResource`,
            resource,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletGetWalletBlance(observe?: 'body', reportProgress?: boolean): Observable<WalletBalanceResponse>;
    public walletGetWalletBlance(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletBalanceResponse>>;
    public walletGetWalletBlance(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletBalanceResponse>>;
    public walletGetWalletBlance(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WalletBalanceResponse>(`${this.basePath}/api/Wallet/GetUserWalletBalance`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletGetWalletByUserId(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public walletGetWalletByUserId(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public walletGetWalletByUserId(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public walletGetWalletByUserId(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/Wallet/GetUserWalletByUserId`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param transactionType 
     * @param searchWord 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletGetWalletUpdateTransactions(creatorId?: string, transactionType?: string, searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<WalletUpdateModelDto>;
    public walletGetWalletUpdateTransactions(creatorId?: string, transactionType?: string, searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletUpdateModelDto>>;
    public walletGetWalletUpdateTransactions(creatorId?: string, transactionType?: string, searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletUpdateModelDto>>;
    public walletGetWalletUpdateTransactions(creatorId?: string, transactionType?: string, searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (transactionType !== undefined && transactionType !== null) {
            queryParameters = queryParameters.set('transactionType', <any>transactionType);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WalletUpdateModelDto>(`${this.basePath}/api/Wallet/GetWalletUpdateTransactions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public walletUpdateWalletBalance(model: WalletUpdateModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public walletUpdateWalletBalance(model: WalletUpdateModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public walletUpdateWalletBalance(model: WalletUpdateModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public walletUpdateWalletBalance(model: WalletUpdateModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling walletUpdateWalletBalance.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/Wallet/UpdateWalletBalance`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
